/* eslint-disable react/prop-types */
import React from "react";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  outterContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  sideItemContainer: {
    flex: "1 0 0",
    minWidth: 0,
  },
}));

const ComparatorLayout = ({ left, center, right, centerClassName = {} }) => {
  const classes = useStyles();

  return (
    <Box className={classes.outterContainer}>
      <Box className={classes.sideItemContainer}>{left}</Box>
      <Box className={centerClassName}>{center}</Box>
      <Box className={classes.sideItemContainer}>{right}</Box>
    </Box>
  );
};

export default ComparatorLayout;
